import {Component, Input, OnInit} from '@angular/core';
import {IonCol, IonRow} from '@ionic/angular/standalone';

@Component({
  selector: 'app-column-content',
  templateUrl: './column-content.component.html',
  styleUrls: ['./column-content.component.scss'],
  imports: [
    IonCol,
    IonRow
  ]
})
export class ColumnContentComponent  implements OnInit {

  @Input() title: string = '';
  @Input() content: string = '';
  constructor() { }

  ngOnInit() {}

}
